class RouteSummaryDamagedSKUs extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteSummaryDamagedStock";

    super(entityName);

    const options = Monet.Grid.Utils.paginationOptions;

    if (!App.Forms[this.entityName]) {
      App.Forms[this.entityName] = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true
        },
        columnToOrders: [],
        ordersIds: []
      };
    }

    if (!App.Objects[this.entityName]) {
      App.Objects[this.entityName] = this;
    }
  }

  getFieldsToGridLayout = callback => {
    
    try {
      const ajax = new Monet.Ajax();
      const url = `form/${this.entityName}/index`;

      ajax.url = url;
      ajax.success = data => {
        if (data) {
          App.Forms[this.entityName].layout["index"] = data;
        }
        if (callback) {
          callback();
        }
      };

      ajax.error = function(response) {
        Monet.Configurations.errorNotification(null, response);
      };

      ajax.send();
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on get grid layout on DamagedStock monitoring route"
      ).console();
    }
  };

  updateGrid = (filter, callback) => {
    try {
      const dataProvider = App.Forms[this.entityName].dataProvider;
      const grid = App.Forms[this.entityName].table;

      if (filter.criteriaChain.length) {
        const { criteriaChain } = filter;
        const activesFilters = criteriaChain[0].and;

        const columns = grid.getColumns();

        let arrayOfData = App.Forms.RouteSummaryStock.staticData || [];
        arrayOfData = arrayOfData.filter(item => item.damaged?.$display);

        const loading = new Monet.UI.LoadingData();
        loading.init();
        loading.show();

        const gridGeneralFunctions = Greenmile.Grid.GeneralFunctions;
        arrayOfData = gridGeneralFunctions.getDataFilteredByClient(activesFilters, arrayOfData);

        arrayOfData = arrayOfData.map(item => new App.Models.StockLine(item));

        const parsedData = new App.Collections.RouteSummaryStock();

        arrayOfData.forEach((item) => {          
          parsedData.add(item);
        });

        if (callback) {
          callback(this.entityName, columns, parsedData, false);
        }

        loading.hide();
      } else {
        dataProvider.setData([]);
        grid.invalidate();
        Monet.Grid.Utils.hideGridNoResult(this.entityName);
        Monet.Grid.Utils.showGridNoResult(this.entityName);
      }
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on update DamagedStock monitoring route",
        e
      ).console();
    }
  };

  getFilter = () => {
    const filter = {
      criteriaChain: [],
      sort: []
    };

    const columnToOrders = App.Forms[this.entityName].columnToOrders || [];
    const _filter = App.Forms[this.entityName].filterBuilder;

    if (_filter) {
      const criteriaByFilterBuilder = _filter.getCriteriaChain();
      filter.criteriaChain = criteriaByFilterBuilder.criteriaChain;

      for (let index in filter.criteriaChain) {
        const criteria = filter.criteriaChain[index];

        for (let key in criteria) {
          const chain = criteria[key];
          
          for (let i in chain) {
            let value = chain[i].attr;

            chain[i].attr = value;
          }
        }
      }
    }

    columnToOrders.forEach(item => {
      filter.sort.push({
        attr: field,
        type: item.order
      });
    });

    return filter;
  };
}

App.Routers.RouteSummaryDamagedStock = RouteSummaryDamagedSKUs;
